import { FILTER_VALUES } from '../../../../constants/FilterConstants';
import {
  getMonthlyPostingFinalizedByDisplayName,
  getMonthlyPostingFinalizedByUser,
  getMonthlyPostingProductName,
} from '../utils/monthlyFinalizedPostingHelpers';

const getApproverId = (posting) => getMonthlyPostingFinalizedByUser(posting)?.id ?? null;

export const mapPostingToFinalizedRow = (posting, productCategories) => ({
  id: posting.id != null ? String(posting.id) : '—',
  postingId: posting.postingId ?? '—',
  productType: getMonthlyPostingProductName(posting, productCategories),
  startDate: posting.startDate ?? null,
  endDate: posting.endDate ?? null,
  approverName: getMonthlyPostingFinalizedByDisplayName(posting, 'Pending'),
  approverId: getApproverId(posting),
  postingDate: posting.postingDate ?? null,
});

export const userListToCreatedByOptions = (users) => {
  if (!Array.isArray(users)) return [];

  return users
    .map((user) => {
      const id = user?.id;
      if (id == null) return null;

      const firstName = user?.firstName ?? user?.first_name ?? '';
      const lastName = user?.lastName ?? user?.last_name ?? '';
      const name = `${firstName} ${lastName}`.trim() || `User ${id}`;

      return { id, name, value: id };
    })
    .filter(Boolean);
};

export const selectFinalizedFilters = (state) => state.monthlyReconciliationFilter?.finalized ?? {};

const COLUMN_TO_API_FIELD = {
  finalizedDate: 'updatedAt',
  productType: 'x3ProductName',
  postingId: 'postingId',
  approverName: 'createdBy',
};

const API_FIELD_TO_COLUMN = Object.fromEntries(
  Object.entries(COLUMN_TO_API_FIELD).map(([columnId, apiField]) => [apiField, columnId]),
);

export const parseFinalizedSortParam = (sortParam) => {
  if (!sortParam || typeof sortParam !== 'string') return { id: 'finalizedDate', desc: true };

  const [field, order] = sortParam.split(':');

  return {
    id: API_FIELD_TO_COLUMN[field] ?? 'finalizedDate',
    desc: (order || 'DESC').toUpperCase() === 'DESC',
  };
};

export const buildFinalizedSortParam = (columnId, desc) => {
  const apiField = COLUMN_TO_API_FIELD[columnId] ?? 'updatedAt';

  return `${apiField}:${desc ? 'DESC' : 'ASC'}`;
};

export const buildFinalizedQueryParams = (filterParams, defaultPage, defaultPerPage) => {
  const toId = (value) => (value && typeof value === 'object' ? value?.value ?? value?.id ?? value : value);
  const toCommaSeparated = (rawValue) => {
    if (Array.isArray(rawValue)) {
      const ids = rawValue.map(toId).filter((value) => value != null && value !== '');

      return ids.length > 0 ? ids.join(',') : undefined;
    }

    if (rawValue != null && rawValue !== '') return String(toId(rawValue));

    return undefined;
  };

  const productRaw = filterParams[FILTER_VALUES.PRODUCT_TYPE];
  const productNames = Array.isArray(productRaw)
    ? productRaw
        .map((value) => (value && typeof value === 'object' ? value?.name ?? value?.value ?? value?.id : value))
        .filter(Boolean)
    : productRaw != null && productRaw !== ''
    ? [productRaw]
    : [];

  return {
    search: filterParams.searchText?.trim() || undefined,
    x3ProductNames: productNames.length > 0 ? productNames.join(',') : undefined,
    startDate: filterParams[FILTER_VALUES.START_DATE] || undefined,
    endDate: filterParams[FILTER_VALUES.END_DATE] || undefined,
    finalizedBy: toCommaSeparated(filterParams[FILTER_VALUES.CREATED_BY]),
    page: filterParams.pageNumber ?? defaultPage,
    perPage: filterParams.rowsPerPage ?? defaultPerPage,
    sort: filterParams.sort ?? 'updatedAt:DESC',
  };
};
